<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateSeason)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Season - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Season Name</label>
                  <md-input v-model="name" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="period" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Period</label>
                  <md-select v-model="period" name="period">
                    <md-option value="">Select Period</md-option>
                    <md-option value="1">Autumn</md-option>
                    <md-option value="2">Spring</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="status" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>rule</md-icon>
                  <label>Status</label>
                  <md-select v-model="status" name="status">
                    <md-option value="">Select Status</md-option>
                    <md-option value="1">Full Active</md-option>
                    <md-option value="2">Active</md-option>
                    <md-option value="3">Inactive</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Season
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      seasonID: null,
      seasons: [],

      name: null,
      period: null,
      status: null
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateSeason() {
      let data = {
        name: this.name,
        period: this.period,
        status: this.status
      };
      var post_data = {};
      for (const field in data) {
        if (
          data[field] === null ||
          data[field] === undefined ||
          data[field] === ""
        ) {
          continue;
        }
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          post_data[field] = data[field];
        }
      }
      this.$store
        .updateSeason(post_data, this.seasonID)
        .then(response => {
          this.$notify({
            message: "Season updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.seasonID = this.$route.params.id;
  }
};
</script>
